import { PublicSiteState, emptyAppState } from '../components/public_site.main.mod'
import { stateful, none, Widget } from 'widgets-for-react'
import { AppState } from '../components/cms/state/types.gen'
import { PublicSiteCustomRoutes } from '../components/public_site/custom_pages/types.mod'
import { application } from '../components/public_site/application.mod'
import { header } from '../components/public_site/templates/header.mod'
import { footer } from '../components/public_site/templates/footer.mod'
import { notfound_page } from '../components/public_site/templates/error_page.mod'
import { loader } from '../components/public_site/templates/loader.mod'
import { page } from '../components/public_site/templates/page.mod'
import { styleguide, custom_page2, search } from '../components/public_site/custom_pages/custom_pages.mod'
import ReactDOM from 'react-dom'

import React from 'react';
import { I18nextProvider } from 'react-i18next'
import i18next, { i18n } from 'i18next'
import nl from '../locales/nl'
import { jsxToWidget } from '../components/cms/blocks/utils.gen'

const i18n = function<I> (options: i18next.InitOptions) {
  i18next.init(options)
  return function(children: JSX.Element): Widget<I> {
    return jsxToWidget<I>(
      <I18nextProvider i18n={ i18next }>
        { children }
      </I18nextProvider>
    )
  }
}


const bootstrap = () =>
  ReactDOM.render(
    i18n<AppState<PublicSiteState, PublicSiteCustomRoutes>>({
      lng: window.wp.language,
      debug: false,
      initImmediate: true,
      resources: { nl }
    })(
      stateful<AppState<PublicSiteState, PublicSiteCustomRoutes>>()(
        application(
          { rootpath: '', rootpath_to_ignore: '/portal', login_address: '/portal' },
          header,
          footer,
          notfound_page,
          loader,
          page,
          { styleguide, custom_page2, search }
        )
      )({
        current_widget: none(),
        route: {
          kind: '404'
        },
        state: emptyAppState(page)
      }).run(_ => null)
    ).run(_ => null),
    document.getElementById('react-content')
  )

document.addEventListener('DOMContentLoaded', () => bootstrap())



// WEBPACK FOOTER //
// ./Client/custom_views/app.tsx